import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const NESTEDPAGEBLOCK_LEGACY_FIELD_ORDER = [];

const {
  nestedPageBlockDescriptor: _generatedNestedPageBlockDescriptor,
  nestedPageBlockBlocDefinition,
  nestedPageBlockDashboardLayout,
  nestedPageBlockConfig,
  nestedPageBlockResolveConfig,
  nestedPageBlockProperties,
} = doodBlockConfig(
  {
    name: "Nested page",
    componentType: 'NestedPageBlockComponent',
    category: 'system',
    description: "Nested page.",
    keywords: [],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function nestedPageBlockDescriptor(): IBlockDescriptor;
export function nestedPageBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function nestedPageBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedNestedPageBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedNestedPageBlockDescriptor, nestedPageBlockProperties, fieldOrder);
}

export {
  nestedPageBlockBlocDefinition,
  nestedPageBlockDashboardLayout,
  nestedPageBlockProperties,
  nestedPageBlockConfig,
  nestedPageBlockResolveConfig,
};

export type NestedPageBlockConfig = typeof nestedPageBlockConfig;
